import axios from "axios";

const getIpData = async () => {
  try {
    const response = await axios.get(
      "https://ipinfo.io/json?token=cbe652e779e0c6"
    );

    if (response && response.data) {
      return response.data;
    } else {
      console.error("No data received from the API.");
      return null;
    }
  } catch (error) {
    console.error("Error in getIpData:", error);
    return null;
  }
};

const setGTMLocationData = async () => {
  // console.log("setGTMLocationData");
  try {
    let gtmLocationData = localStorage.getItem("gtmLocationData");
    // console.log("gtmLocationData", gtmLocationData);
    if (!gtmLocationData) {
      gtmLocationData = await getIpData();
      if (gtmLocationData) {
        localStorage.setItem(
          "gtmLocationData",
          JSON.stringify(gtmLocationData)
        );
      }
      return gtmLocationData;
    } else {
      return JSON.parse(gtmLocationData);
    }
  } catch (error) {
    console.error("Error in setGTMLocationData:", error);
    return null;
  }
};

export { setGTMLocationData };
